import { bindActionCreators } from 'redux';
import { BorderGridContainer, GridBox, SpacerWrapper } from '@ahmdigital/ui';
import { connect } from 'react-redux';
import { includes, isEmpty } from 'lodash/fp';
import React, { useEffect } from 'react';

import { Customer } from '../../../../../selectors/select-customer/types';
import { RootState } from '../../../../../reducers';
import constants from '../../../../../ahm-constants';
import CustomerActions, { CustomerActionType } from '../../../../../actions/customer';
import loadPriceForComponentProps from '../../../../../models/price/load-price-for-component-props';
import PriceActions, { PriceActionsType } from '../../../../../actions/price';
import PriceService, { Prices } from '../../../../../models/price';
import PricingDrawer from '../../../../../components/pricing-drawer';
import ProductPropType from '../../../../../types/product';
import Products from './components/products';
import selectCustomer from '../../../../../selectors/select-customer';

export type NoGapProductsProps = {
  actions: CustomerActionType & {
    price: PriceActionsType;
  };
  customer: Customer;
  isLoadingPrice: boolean;
  prices: Prices;
  products: {
    [key: string]: ProductPropType;
  };
  useFutureEffectiveDate: boolean;
};

const PRODUCT_TYPES = [constants.PRODUCT_TYPE.PACKAGE, constants.PRODUCT_TYPE.EXTRAS];

const NoGapProducts = ({
  actions,
  customer,
  isLoadingPrice,
  prices,
  products,
  useFutureEffectiveDate,
}: NoGapProductsProps) => {
  const isProductWithHospitalServices = customer.productType === constants.PRODUCT_TYPE.PACKAGE;

  const customerChange = PriceService.getKey('', customer);

  const changedProducts = JSON.stringify(products);

  useEffect(() => {
    if (!isEmpty(products)) {
      loadPriceForComponentProps.componentDidMount({ actions, customer, products, useFutureEffectiveDate });
    }
  }, [customerChange, changedProducts, useFutureEffectiveDate]);

  useEffect(() => {
    if (!isEmpty(products)) {
      actions.customer.changeHospitalExcess('750');
      if (!includes(customer.productType, PRODUCT_TYPES)) {
        actions.customer.changeProductType(constants.PRODUCT_TYPE.PACKAGE);
      }
      loadPriceForComponentProps.componentDidMount({ actions, customer, products, useFutureEffectiveDate });
    }
  }, []);

  if (isEmpty(products)) {
    return null;
  }

  return (
    <>
      <BorderGridContainer hideBorderTop>
        <GridBox padding="0">
          <SpacerWrapper variant={['paddingTopSpacer3', 'paddingBottomSpacer3']}>
            {/* @ts-expect-error - Automatic, Please fix when editing this file */}
            <Products
              {...{
                customer,
                isLoadingPrice,
                isProductWithHospitalServices,
                prices,
                productTypes: PRODUCT_TYPES,
                products,
                useFutureEffectiveDate,
              }}
            />
          </SpacerWrapper>
        </GridBox>
      </BorderGridContainer>
      <PricingDrawer isProductWithHospitalServices={isProductWithHospitalServices} />
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  customer: selectCustomer(state),
  isLoadingPrice: state.price.loading,
  prices: state.price.data,
  products: state.product.data,
  useFutureEffectiveDate: state.price.useFutureEffectiveDate,
});

// @ts-expect-error - Automatic, Please fix when editing this file
const mapDispatchToProps = (dispatch) => ({
  actions: {
    customer: bindActionCreators(CustomerActions, dispatch),
    price: bindActionCreators(PriceActions, dispatch),
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(NoGapProducts);

export { NoGapProducts as NoGapProductsForTest, mapStateToProps };
